module.exports = __webpack_public_path__ + "static/media/read1.e5eb2b85.svg";